<template>
   <div>
         <ModalCadastroEdicao ref="modalCadastroEdicao"
                            :edicao="edicao"
                            :tipoClassificacao="tipoClassificacao"
                            :tipoClassificacaoNome="tipoClassificacaoNome"
                            :idTipo="idTipo"
                            :nomeTipo="nomeTipo"
                            :descricaoTipo="descricaoTipo"
                            :tiposFontes="tiposFontes"
                            :tipoFonte="tipoFonteId"
                            :fontes="fontes"
                            :publicoAlvo="publicoAlvo"
                            :fonte="fonteId"
                            :publico="publicoAlvoId"
                             @tipoSalvo="buscarTipo"
                             />

      <div class="sub-menu"><span>Cadastrar/Editar Classificaçoes de Simulados</span></div>
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="publico_alvo">Público Alvo</label>
            <select class="form-control" id="publico" v-model="selectedPublico"  v-on:change="cadastrarEditar" >
              <option v-if="publicoAlvo.length > 0" value="-1">Selecione</option>
              <option v-if="publicoAlvo.length > 0" value="" data-tipoNome="Público Alvo" :data-tipo="publicoAlvoConst">Cadastrar novo publico alvo</option>
              <option v-for="publico in publicoAlvo" :data-value="publico.id" :data-nome="publico.sigla" data-tipoNome="Público Alvo" :data-tipo="publicoAlvoConst" :data-descricao="publico.publico">{{ publico.publico }}</option>
              <option v-if="publicoAlvo.length == 0" value="">Carregando...</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="Modalidade">Modalidade</label>
            <select class="form-control" id="modalidade" v-model="selectedModalidade" v-on:change="cadastrarEditar">
              <option v-if="modalidades.length > 0" value="-1">Selecione</option>
              <option v-if="modalidades.length > 0" value="" data-tipoNome="Modalidade" :data-tipo="modalidadeConst">Cadastrar nova modalidade</option>
              <option v-for="modalidade in modalidades" :data-value="modalidade.id" :data-fonteId="modalidade.fonte.id" :data-publicoAlvoId="modalidade.publico.id" :data-nome=" modalidade.modalidade" data-tipoNome="Modalidade" :data-tipo="modalidadeConst" :data-descricao="modalidade.descricao">{{ modalidade.descricao }}</option>
              <option v-if="modalidades.length == 0" value="">Carregando...</option>
            </select>
        </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label for="fonte">Fonte</label>
            <select class="form-control" id="fonte" v-model="selectedFonte" v-on:change="cadastrarEditar">
              <option v-if="fontes.length > 0" value="-1">Selecione</option>
              <option  v-if="fontes.length > 0" value="" data-tipoNome="Fonte" :data-tipo="fonteConst">Cadastrar nova fonte</option>
              <option v-for="fonte in fontes" :data-value="fonte.id" :data-nome="fonte.fonte" data-tipoNome="Fonte" :data-tipo="fonteConst" :data-descricao="fonte.descricao" :data-tipoFonteId="fonte.tipo_fonte.id">{{ fonte.descricao }}</option>
              <option v-if="fontes.length == 0" value="">Carregando...</option>
            </select>
        </div>
      </div>
      </div>
      <div class="sub-menu"><span>Tipos de Simulado</span></div>
            <div class="row">
            <div class="col-12 col-md-4">
               <div class="form-group">
            <label for="tipo_simulado">Tipo de Simulado</label>
            <select class="form-control" id="tipo_simulado" v-model="selectedTipoSimulado" v-on:change="cadastrarEditar">
              <option v-if="tiposSimulado.length > 0" value="-1">Selecione</option>
              <option v-if="tiposSimulado.length > 0" value="" data-tipoNome="Tipo de Simulado" :data-tipo="tipoConst">Cadastrar novo tipo de simulado</option>
              <option v-for="tipo in tiposSimulado" :data-value="tipo.id" :data-descricao="tipo.descricao" data-tipoNome="Tipo de Simulado" :data-tipo="tipoConst">{{ tipo.descricao }}</option>
              <option v-if="tiposSimulado.length == 0" value="">Carregando...</option>
            </select>
             </div>
        </div>
      </div>
   </div>
</template>

<script>
import ConteudoAPI from '@/api/conteudo-api'
import SimuladoAPI from '@/api/simulado-api'
import ModalCadastroEdicao from '@/modules/Admin/components/ModalCadastroEdicaoClassificacoes'
import Constants from '@/core/constants/constants'

export default {
  name: 'SimuladoClassificacoes',
  components: { ModalCadastroEdicao },
  data () {
    return {
      publicoAlvo: [],
      edicao: false,
      modalidades: [],
      fontes: [],
      tiposSimulado: [],
      selectedPublico: '',
      selectedModalidade: '',
      selectedTipoSimulado: '',
      selectedFonte: '',
      tipoClassificacaoNome: '',
      nomeTipo: '',
      idTipo: '',
      descricaoTipo: '',
      publicoAlvoConst: Constants.PUBLICO_ALVO,
      modalidadeConst: Constants.MODALIDADE,
      fonteConst: Constants.FONTE,
      tipoConst: Constants.TIPO_SIMULADO,
      tipoClassificacao: '',
      tiposFontes: [],
      tipoFonteId: '',
      fonteId: '',
      publicoAlvoId: ''
    }
  },
  mounted () {
    ConteudoAPI.listarModalidades().then(data => {
      this.modalidades = data
      this.selectedModalidade = -1
    })
    ConteudoAPI.listarPublicos().then(data => {
      this.publicoAlvo = data
      this.selectedPublico = -1
    })
    ConteudoAPI.listarFontes().then(data => {
      this.fontes = data
      this.selectedFonte = -1
    })
    SimuladoAPI.listarTipos().then(data => {
      this.tiposSimulado = data
      this.selectedTipoSimulado = -1
    })
    ConteudoAPI.listarTiposFontes().then(data => {
      this.tiposFontes = data
    })
  },
  methods: {
    cadastrarEditar (e) {
      if (e.target.options.selectedIndex > -1 && e.target.value !== '-1') {
        let dataSet = e.target.options[e.target.options.selectedIndex].dataset
        this.tipoClassificacao = dataSet.tipo
        this.tipoClassificacaoNome = dataSet.tiponome
        this.edicao = true
        if (typeof dataSet.value === 'undefined') {
          this.edicao = false
        }
        this.descricaoTipo = dataSet.descricao
        this.idTipo = dataSet.value
        this.nomeTipo = dataSet.nome
        this.tipoFonteId = dataSet.tipofonteid
        this.fonteId = dataSet.fonteid
        this.publicoAlvoId = dataSet.publicoalvoid
        this.$nextTick(() => {
          this.$refs.modalCadastroEdicao.show()
        })
      }
    },
    buscarTipo (tipo) {
      tipo = parseInt(tipo)
      switch (tipo) {
        case Constants.PUBLICO_ALVO:
          this.publicoAlvo = []
          this.selectedPublico = ''
          ConteudoAPI.listarPublicos().then(data => {
            this.publicoAlvo = data
            this.selectedPublico = -1
          })
          break
        case Constants.MODALIDADE:
          this.modalidades = []
          this.selectedModalidade = ''
          ConteudoAPI.listarModalidades().then(data => {
            this.modalidades = data
            this.selectedModalidade = -1
          })
          break
        case Constants.FONTE:
          this.fontes = []
          this.selectedFonte = ''
          ConteudoAPI.listarFontes().then(data => {
            this.fontes = data
            this.selectedFonte = -1
          })
          break
        case Constants.TIPO_SIMULADO:
          this.tiposSimulado = []
          this.selectedTipoSimulado = ''
          SimuladoAPI.listarTipos().then(data => {
            this.tiposSimulado = data
            this.selectedTipoSimulado = -1
          })
          break
        default:
          break
      }
    }
  }
}
</script>
